import apiFetch from '../apiFetch'

export default function () {
  return apiFetch({server: 'oldMagavision', endPoint: '', method: 'GET', body: null, mode: 'cors', credentials: 'omit'})
}